<template>
    <div id="legal-documentation" class="legal-documentation-wrapper pt-8 scroll-mt-56">
        <HeadingBarComponent :step="7" />
        <div class="flex">
            <!-- Left Side -->
            <div class="basis-1/2 px-8">
                <h3 class="mb-4">Documentation</h3>
                <InputComponent classNames="cursor-pointer" label="W-8BEN" :value="isLoadingW8BEN ? 'Loading...' : 'View PDF'" @click.native="generateW8BENAdminUrl()" icon="view.svg" />
                <HrComponent />
            </div>
        </div>
        <div class="px-8">
            <h3 class="mb-4">Important Policies and Disclosures</h3>
            <CheckboxComponent label="The following documents include important information relating to our business and how you may trade through us. Please read them carefully and confirm your agreement to them where indicated below." :value="!!submission.legal_documentation.policies_and_disclosures_confirmation" />
            <HrComponent class="mt-2" />

            <h3 class="mb-4" @click="quickView = !quickView"><span class="icon-chevron mr-2 text-sm" :class="[quickView ? '' : 'active']"></span> Client Agreements</h3>
            <div :class="[quickView ? 'flex' : '']">
                <CheckboxComponent :label="!quickView ? 'I confirm that I have read, and understand and agree to, the terms of the Client Agreement. I confirm that, should I be accepted as a client of AMT Futures Limited, I will be acting as principal and not on behalf of any other person or organisation.' : ''" :value="!!submission.legal_documentation.client_agreement_confirmation" />

                <CheckboxComponent :label="!quickView ? 'The Firm may execute an order on the Client\'s behalf outside a trading venue (including a UK or an EU Regulated Venue).' : ''" :value="!!submission.legal_documentation.agree_execute_order_on_your_behalf" />

                <CheckboxComponent :label="!quickView ? 'The Firm may place the Client\'s monies in a qualifying money market fund.' : ''" :value="!!submission.legal_documentation.agree_monies_placed_money_market_fund" />

                <CheckboxComponent :label="!quickView ? 'In the case of a limit order in shares admitted to trading on a regulated market or traded on a regulated market, multilateral trading facility or organised trading facility which is not immediately executed, the Firm is not bound to facilitate the earliest possible execution of that order by making it public in an easily accessible manner.' : ''" :value="!!submission.legal_documentation.agree_case_of_limit_order" />

                <CheckboxComponent :label="!quickView ? 'The information that the Client has provided to the Firm to allow the Firm to assess the appropriateness of the activities and services the Firm is providing to the Client is accurate and complete.' : ''" :value="!!submission.legal_documentation.confirm_info_is_accurate" />

                <CheckboxComponent :label="!quickView ? 'Where the Firm trades on a futures and options exchange, the contract specifications provided by these exchanges satisfy the requirements of a “Key Information Document” under the Packaged Retail and Insurance-based Investment Products Regulation.' : ''" :value="!!submission.legal_documentation.agree_satisfy_key_info_document" />

                <CheckboxComponent :label="!quickView ? 'The Firm may enter into arrangements for securities financing transactions in respect of financial instruments held by the Firm on the Client\'s behalf or otherwise use such financial instruments for the Firm\'s own account or the account of another client.' : ''" :value="!!submission.legal_documentation.agree_securities_financing_arrangements" />

                <CheckboxComponent :label="!quickView ? 'The Firm may enter into arrangements for securities financing transactions in respect of financial instruments held by the Firm on the Client\'s behalf in an omnibus account held by a third party, or otherwise use financial instruments held in such an account for the Firm\'s own account or for the account of another client.' : ''" :value="!!submission.legal_documentation.agree_securities_financing_arrangements_third_party" />

                <CheckboxComponent :label="!quickView ? 'The Client\'s custody assets may be registered or recorded in the Firm\'s name.' : ''" :value="!!submission.legal_documentation.agree_custody_assets_registered_in_our_name" />

                <CheckboxComponent :label="!quickView ? 'The Firm may deposit financial instruments held on the Client\'s behalf with a third party in a third country that does not regulate the holding and safekeeping of financial instruments for the account of another person.' : ''" :value="!!submission.legal_documentation.agree_may_deposit_financial_instruments_with_third_party" />

                <CheckboxComponent :label="!quickView ? 'The Firm will not notify you if the value of your portfolio falls by more than 10% in any quarter, as you receive monthly statements from the Firm and can request a statement at any time.' : ''" :value="!!submission.legal_documentation.agree_not_notify_of_portfolio_value_fall" />


                <div v-if="!quickView">
                    <h3 class="my-4">Professional Agreements</h3>
                    <div class="flex">
                        <!-- Left Side -->
                        <div class="basis-1/2 px-8">
                            <InputComponent label="Is Professional Agreement?" :value="submission.financial_circumstances.opt_in_as_professional_customer ? 'Yes' : 'No'" />
                        </div>
                    </div>
                </div>

                <!-- DEPRECATED: Only conditionally shown if the user has checked this box in the past -->
                <CheckboxComponent v-if="submission.legal_documentation.agree_custody_assets_used_for_other_purposes" :label="!quickView ? 'I agree and acknowledge that AMT Futures Limited may use your custody assets for other purposes.' : ''" :value="!!submission.legal_documentation.agree_custody_assets_used_for_other_purposes" />
            </div>
            <HrComponent />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import HeadingBarComponent from "@adminComponents/misc/HeadingBarComponent";
import HrComponent from '@adminComponents/misc/HrComponent';
import InputComponent from '@adminComponents/inputs/InputComponent';
import CheckboxComponent from '@adminComponents/inputs/CheckboxComponent';

export default {
    name: "LegalDocumentationComponent",
    components: {
        HeadingBarComponent,
        HrComponent,
        InputComponent,
        CheckboxComponent
    },
    computed: {
        ...mapGetters(["submission"])
    },
    data: function () {
        return {
            isLoadingW8BEN: false,
            quickView: true
        };
    },
    methods: {
        ...mapActions(["doGenerateW8BENAdminUrl"]),
        generateW8BENAdminUrl() {
            this.isLoadingW8BEN = true;
            this.doGenerateW8BENAdminUrl(this.$route.params.user).then((response) => {
                let downloadUrl = response.file_url;
                window.open(downloadUrl, "_blank");
                this.isLoadingW8BEN = false;
            });
        },
    },
};
</script>
